import axios from "../plugins/parseAxios";

export class CurrencyRateAPI {
  static getCurrencyRateByDate(payload) {
    return axios.post("functions/getCurrencyRateByDate", payload);
  }
  static getLastCurrencyRate(payload) {
    return axios.post("functions/getLastCurrencyRate", payload);
  }
}